import React from 'react';

import ListViewFooter from './ListViewFooter';

// import NewListViewHeaderField from 'ROOT/src/components/list/NewListViewHeaderField';
import NewListViewHeaderField from './NewListViewHeaderField';
import NewListViewField from './NewListViewField';
import ListViewFilterContainer from 'ROOT/src/components/list/listViewFilterContainer';
import MoreOptions from 'ROOT/src/components/formElements/MoreOptions';
import ListViewTableTree from './listViewTableTree';
import ListViewTableDropZone from 'ROOT/src/components/list/listViewTableDropZone';
import TickBox from 'ROOT/src/components/formElements/TickBox';
import sAction from 'sAction';

import ListViewTable2Orig from 'ROOT/src/components/list/listViewTable2';

class ListViewTable extends ListViewTable2Orig {
    getListView() {
        const showListViewFooter = true;
        const showCheckboxes = false;

        const filterValues = sAction.getFilterKeyValuePairs(this.props.data.filter);
        let data = this.props.data;
        const prefix = this.props.prefix;
        const orderBy = data.orderBy;
        const selectCallBack = this.props.parent.props.selectCallBack;
        const selectedSize = data.selected.size;
        const fieldWithActiveFiltering = {};
        const isWidget = this.props?.isWidget;
        data.filter.forEach((filter) => {
            fieldWithActiveFiltering[filter.field] = filter.filters;
        });
        const rows = [];
        let header = [];

        const allowedModulesDownloadDialog = [
            'aon_portal_documents',
            'aon_event_response_files',
            'aon_notices_and_fixes',
        ];

        // filter for immutable.js filter out rows with width 0% (hidden rows)
        data.rows.forEach((row, rowKey) => {
            if (row.get('width') == '0%') {
                data = data.deleteIn(['rows', rowKey]);
            }
        });

        if (
            data.type != 'subpanel' &&
      data.type != 'reportWindow' &&
      data.selectedActive == true
        ) {
            let disabledTickBox = false;
            const selectPage = data.selectPage;
            if (data.selected == 'all') {
                disabledTickBox = true;
            }
            if (showCheckboxes) {
                header = [
                    <div
                        className="listViechCheckBoxTd listViwTableCell checkBoxRow"
                        key="select"
                    >
                        <TickBox
                            disabled={disabledTickBox}
                            checked={selectPage}
                            onClick={(e) => {
                                sAction.toggleAll(!selectPage, prefix);
                                sAction.dataSet(prefix + '/selectPage', !selectPage);
                            }}
                        />
                    </div>,
                ];
            }
        }

        const checkboxColum = [];
        if (
            data.type != 'subpanel' &&
            data.type != 'reportWindow' &&
            data.type != 'widget' &&
            data.selectedActive == true &&
            showCheckboxes
        ) {
            data.records.forEach((record, key) => {
                let selected = false;
                let disabledTickBox = false;
                let lineRecord = null;
                if (data.selected != 'all') {
                    lineRecord = data.selected.find((id) => id === record);
                    if (lineRecord != null) {
                        selected = true;
                    }
                } else {
                    selected = true;
                    disabledTickBox = true;
                }
                checkboxColum.push(
                    <div className="newListViewLine newListViewLineCheckBox" key={key}>
                        <TickBox
                            disabled={disabledTickBox}
                            key={selected}
                            onClick={(e) =>
                                sAction.toggleLine(record, e.target.checked, prefix)
                            }
                            checked={selected}
                        />
                    </div>,
                );
            });
        }
        data.rows.forEach((row, rowKey) => {
            const fieldName = row.def.get('name');
            const disabled = row.disabled;
            const fieldColors = data.colors.get(fieldName);
            const fieldIcons = data.icons.get(fieldName);
            const lines = [];
            // extra data for file name - aon_portal_documents -> eye icon (i) get file download popup
            // instead of file right panel preview
            let extraData = null;
            if (row.key === 'NAME' && allowedModulesDownloadDialog.includes(data.get('modul'))) {
                data.rows.forEach((row, rowKey) => {
                    if (row.key === 'FILENAME') {
                        extraData = row.records;
                    }
                });
            }
            row.records.forEach((line, lineKey) => {
                let lineExtraData = null;
                if (extraData) {
                    lineExtraData = extraData.get(lineKey);
                }
                let module = line.get('module');
                if (!module) {
                    module = data.modul;
                }
                lines.push(
                    <NewListViewField
                        index={lineKey}
                        key={lineKey}
                        row={row}
                        rowIndex={rowKey}
                        line={line}
                        modul={module}
                        editModule={data.modul}
                        listType={data.type}
                        selectCallBack={selectCallBack}
                        uuid={data.records.get(lineKey)}
                        prefix={prefix}
                        getIdByIndex={this.getIdByIndex}
                        getPropertyValueByIndex={this.getPropertyValueByIndex}
                        target={this.props.target}
                        forceRightPanel={this.props.forceRightPanel}
                        bcColor={
                            fieldColors != undefined ?
                                fieldColors.get(line.get('value')) :
                                null
                        }
                        icon={
                            fieldIcons != undefined ?
                                fieldIcons.get(line.get('value')) :
                                null
                        }
                        disabled={disabled}
                        isWidget={this.props?.isWidget}
                        extraData={lineExtraData}
                    />,
                );
            });

            let fieldOrder = false;
            if (row.key.toLowerCase() == orderBy) {
                fieldOrder = true;
            }

            let filtering = {
                state: false,
            };
            if (fieldWithActiveFiltering[row.key.toLowerCase()] != undefined) {
                fieldWithActiveFiltering[row.key.toLowerCase()].forEach((filter) => {
                    if (filter.footer == false) {
                        filtering = {
                            state: true,
                        };
                    }
                });
            }
            header.push(
                <NewListViewHeaderField
                    key={rowKey}
                    prefix={prefix}
                    data={row}
                    filterValues={filterValues}
                    asc={data.asc}
                    orderBy={fieldOrder}
                    filter={data.filter}
                    filtering={filtering}
                    openFilter={data.openFilter}
                    actFiltering={data.actFiltering}
                    last={data.rows.size == rowKey + 1}
                    sortable={row.sortable}
                />,
            );
            rows.push(
                <div
                    key={rowKey}
                    data-width={row.width}
                    data-last={data.rows.size == rowKey + 1}
                    className="newListViewRow setWidth"
                >
                    {lines}
                </div>,
            );
        });

        if (data.type == 'subpanel') {
            const lines = [];
            data.records.forEach((record, index) => {
                if (this.props.acl && this.props.acl.get('edit') == false) {
                    return;
                }
                lines.push(
                    <div
                        key={'subpanel_edit_' + index}
                        className="newListViewLine subpanelEditButton"
                    >
                        <MoreOptions
                            className="right"
                            options={[
                                {
                                    label: 'Odebrat',
                                    value: {action: 'removeRel', record: record},
                                },
                            ]}
                            onClick={(e, val) => this.subpanelLineMoreAction(e, val)}
                        >
                            <div className="subpanelLineMoreOptions moreIcon" />
                        </MoreOptions>
                    </div>,
                );
            });
            rows.push(<div key="last">{lines}</div>);
            header.push(<div key="last" className="subpanelEditButton" />);
        }

        let filter = null;
        if (data.openFilterData != null && data.openFilterData.open == true) {
            let actFilter = null;
            let way = prefix;
            data.filter.forEach((f, k) => {
                if (f.field == data.openFilterData.field) {
                    actFilter = f;
                    way = way + '/filter/' + k;
                }
            });
            filter = (
                <ListViewFilterContainer
                    prefix={prefix}
                    way={way}
                    actFilter={actFilter}
                    index={data.filter.size}
                    open={data.openFilterData.open}
                    def={data.openFilterData.def}
                    offset={data.openFilterData.offset}
                />
            );
        }

        let tree = null;
        if (data.listViewTree != null && data.listViewTree.tree !== null) {
            // if (data.type != "rightPanelQuotes") {
            tree = <ListViewTableTree data={data.listViewTree} way={prefix} />;
            // }
        }

        let tableLinesContainerClass = 'newListViewLines';
        if (data.actFiltering == true) {
            tableLinesContainerClass += ' activeFiltering';
        }

        const viewType = sAction.dataGet('view/category');
        return (
            <React.Fragment>
                {data.dropZoneActive == true && <ListViewTableDropZone way={prefix} />}
                {tree}
                <div className="newListView" ref={this.table}>
                    <div className='newListViewContent'>
                        {data.type != 'reportWindow' && (
                            <div className="filterContainer">
                                <div
                                    onClick={() => sAction.activateListViewFiltering(prefix)}
                                    className="icon-filter listViewFilterIcon"
                                    title="Filter"
                                />
                            </div>
                        )}

                        <div
                            onScroll={(e) => this.scroll(e)}
                            className={'newListViewContentInner' + (isWidget ? ' widgetListView' : '')}
                        >
                            {viewType === 'list' ?
                                <div className="newListViewHeaderWrapper">
                                    <div ref={this.header} className="newListViewHeader">
                                        {header}
                                    </div>
                                </div> :
                                <div className="newListViewHeaderWrapperNonListPage">
                                    <div ref={this.header} className="newListViewHeader">
                                        {header}
                                    </div>
                                </div>
                            }
                            <div
                                onMouseOver={(e) => this.mouseOver(e)}
                                onMouseLeave={() => this.removeHover()}
                                className={tableLinesContainerClass}
                            >
                                {data.type != 'subpanel' &&
                  data.type != 'reportWindow' &&
                  data.type != 'widget' &&
                  data.selectedActive == true &&
                  showCheckboxes == true && (
                                    <div className="newListViewRow checkBoxRow">
                                        {checkboxColum}
                                    </div>
                                )}
                                {rows}
                            </div>
                        </div>
                        {filter}
                    </div>
                    {data.type != 'subpanel' && showListViewFooter && (
                        <ListViewFooter
                            module={data.modul}
                            filter={data.filter}
                            offset={data.offset}
                            limit={data.limit}
                            rowCount={data.rowCount}
                            rowTotalCount={data.rowTotalCount}
                            selected={selectedSize}
                            selectedActive={data.selectedActive}
                            page={data.page}
                            prefix={prefix}
                            type={data.type}
                        />
                    )}
                    {data.selected.size != 0 && data.type == 'popup' && (
                        <div
                            onClick={() =>
                                selectCallBack({
                                    id:
                    data.selected !== 'all' ?
                        data.selected.toJS() :
                        data.selected,
                                })
                            }
                            className="listViewPopupSelectButton"
                        >
                            {sAction.translate('LBL_SELECT') +
                ' (' +
                (data.selected.size ?
                    data.selected.size :
                    sAction.translate('LBL_ALL')) +
                ')'}
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}
export default ListViewTable;
